import React from "react";
import PopUpContainer from "../common/PopUp/PopUpContainer";
import PopUpHeader from "../common/PopUp/PopUpHeader";
import PopUpBody from "../common/PopUp/PopUpBody";
import { useNavigate } from "react-router-dom";
import BlackBg from "../common/PopUp/BlackBg";

const SuccessPopUp = ({ setShowPopUp }) => {
  const itemName = "密碼";
  const navigate = useNavigate();

  const confirm = () => {
    setShowPopUp(false);
    navigate("/");
  };

  return (
    <>
      <BlackBg cancel={confirm} />
      <PopUpContainer>
        <PopUpHeader itemName={itemName} />
        <PopUpBody>
          <p className="col-span-full font-chinese justify-self-center text-2xl">
            {" "}
            密碼修改成功！
          </p>
          <button
            onClick={confirm}
            className="col-span-full justify-self-center bg-custom-orange w-20 h-8 hover:brightness-75 rounded-full text-white"
          >
            確認
          </button>
        </PopUpBody>
      </PopUpContainer>
    </>
  );
};

export default SuccessPopUp;
